import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { ModulesSection } from './components/ModulesSection';
import { BonusSection } from './components/BonusSection';
import { ForYouSection } from './components/ForYouSection';
import { ResultsSection } from './components/ResultsSection';
import { PurchaseSection } from './components/PurchaseSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Meta Pixel Injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '26257470350562748');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=26257470350562748&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    return () => {
      // Cleanup not strictly necessary for pixel, but good practice if component unmounts
    };
  }, []);
  return <div className="min-h-screen font-sans bg-offwhite selection:bg-accent selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <ValueProps data-id="element-2" />
      <ModulesSection data-id="element-3" />
      <BonusSection data-id="element-4" />
      <ForYouSection data-id="element-5" />
      <ResultsSection data-id="element-6" />
      <PurchaseSection data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}